import { Navigate, Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";

import { VersionTag } from "../../core/components/VersionTag";
import { getLoggedIn } from "../../core/store/appSlice";
import { getPracticePatientId } from "../../core/store/currentFormSlice";
import { useMainStore } from "../../core/store/mainStore";
import { Header } from "./components/Header";
import { useScrollToTop } from "./utils/useScrollToTop";
import { RELEASE_DONE_PATH, STAFF_FILL_PATH, useWebAppSessionTimeout } from "./utils/webAppSession";

export const WelcomeLayout = () => {
  const isLoggedIn = useMainStore(getLoggedIn);
  const practicePatientId = useMainStore(getPracticePatientId);
  const { pathname } = useLocation();

  useScrollToTop(false);
  // The chooser and the identity step show the household's names, so they end with the session like the form.
  useWebAppSessionTimeout();

  // The chooser runs signed in without a record yet, and the end screens sign out a session that is still there, so
  // none of them may be redirected away just because a session exists (PF-6132, PF-6133). The staff-fill entry signs
  // out a session an earlier frame left in the shared storage before it announces itself.
  if (
    isLoggedIn &&
    practicePatientId &&
    !pathname.startsWith("/welcome/success") &&
    pathname !== RELEASE_DONE_PATH &&
    pathname !== STAFF_FILL_PATH
  ) {
    return <Navigate to={"/form"} replace />;
  }
  return (
    <>
      <Header />
      <Container>
        <ScrollContainer className="scroll-ancestor">
          <OutletContainer>
            <Outlet />
            <VersionTag />
          </OutletContainer>
        </ScrollContainer>
      </Container>
    </>
  );
};

const OutletContainer = styled.div`
  max-width: 600px;
  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  height: 100%;
  overflow: hidden;
`;

const ScrollContainer = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
`;
